const SvgComponent = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
        <path
            fill="#1F2937"
            d="M17.254 5.972 12.48 1.2A.682.682 0 0 0 11.999 1H3.817a1.364 1.364 0 0 0-1.364 1.364v15a1.364 1.364 0 0 0 1.364 1.363H16.09a1.364 1.364 0 0 0 1.363-1.363V6.454a.682.682 0 0 0-.2-.482Zm-4.574 7.982H7.226a.682.682 0 1 1 0-1.363h5.454a.682.682 0 1 1 0 1.364Zm0-2.727H7.226a.682.682 0 0 1 0-1.363h5.454a.682.682 0 1 1 0 1.363ZM12 6.455v-3.75l3.75 3.75h-3.75Z"
        />
    </svg>
)
export default SvgComponent
